export const ORIGIN = {
  CREATE_ACCOUNT_LINK: 'create-account-link',
};
